import React from 'react';

const SelectWidget = ({ settings, value, onChange }) => {
  const options = settings?.options || [];
  const defaultVal = settings?.default;

  React.useEffect(() => {
    if (!value && defaultVal != null) onChange(String(defaultVal));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const selectStyle = {
    padding: '8px 12px',
    border: '1px solid #ccc',
    borderRadius: '6px',
    fontSize: '0.9rem',
    outline: 'none',
    minWidth: '200px',
    background: '#fff',
    cursor: 'pointer',
  };

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={selectStyle}
    >
      <option value="" disabled>Select...</option>
      {options.map((opt, i) => {
        const label = typeof opt === 'object' ? opt.label : String(opt);
        const val = typeof opt === 'object' ? opt.value : opt;
        return (
          <option key={i} value={val}>
            {label}
          </option>
        );
      })}
    </select>
  );
};

export default SelectWidget;
